<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
    </div>

    <v-flex xs12>
      <v-row justify="start">
        <v-col md="12">
          <v-row>
            <v-col cols="12">
              <v-card flat tile>
                <v-card-title>
                  <v-row>
                    <v-col class="d-flex justify-start">
                      <v-btn
                      :disabled="!this.form.coordinates.length"
                      class="ma-1"
                      rounded
                      small
                      depressed
                      color="primary"
                      @click="removePolygon">
                      Borrar polígono
                    </v-btn>
                    <v-btn
                      :disabled="!this.form.coordinates.length"
                      @click="submit"
                      class="ma-1"
                      rounded
                      small
                      depressed
                      color="primary">
                      Guardar
                    </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <div id="map" ref="map" style="width:100%; height: 400px;"></div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </v-layout>
</template>

<script>
import countrycodes from '@/lib/countrycodes'

export default {
  name: 'Providers',
  data () {
    return {
      countrycodes,
      section: 'Polígono de Entregas',
      overlay: false,
      disabled: true,
      map: null,
      poly: null,
      marker: null,
      markers: [],
      array: [],
      lat: 0,
      lng: 0,
      form: {
        coordinates: []
      },
      rules: {
      }
    }
  },
  computed: {
    provider () {
      return this.$store.state.currentProvider.data._id
    }
  },
  async mounted () {
    await this.get()
  },
  methods: {
    async get () {
      this.overlay = true
      try {
        const coordinates = []
        const response = await this.$api.get(`/v1/providers/${this.provider}/settings`)
        if (response && response.polygons && response.polygons.coordinates.length > 0) {
          for (const coor of response.polygons.coordinates[0].slice(0, -1)) {
            coordinates.push({ lat: coor[1], lng: coor[0] })
          }
          this.form.coordinates = coordinates
        }

        if (coordinates.length > 0) {
          const map = this.initMap(coordinates[0])
          const poly = this.polygon(coordinates)
          poly.setMap(map)
          this.setMarkers(coordinates, map)
        } else {
          this.map = this.initMap({ lat: 19.432608, lng: -99.133209 })
          this.poly = this.polygon()
          this.poly.setMap(this.map)
          this.map.addListener('click', this.addLatLng)
        }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    initMap (coordinates) {
      const map = new window.google.maps.Map(this.$refs.map, {
        zoom: 10,
        center: coordinates
      })
      return map
    },
    polygon (path) {
      const options = {
        strokeColor: '#01D28E',
        strokeOpacity: 0.8,
        strokeWeight: 3,
        fillColor: '#01D28E',
        fillOpacity: 0.35
      }
      if (path) options.paths = path

      const poly = new window.google.maps.Polygon(options)
      return poly
    },
    setMarkers (markers, map) {
      const array = []
      for (let i = 0; i < markers.length; i++) {
        const marker = new window.google.maps.Marker({
          position: markers[i],
          map: map,
          draggable: true
        })

        array.push(marker)

        window.google.maps.event.addListener(array[i], 'mousedown', (event) => {
          this.lat = event.latLng.lat()
          this.lng = event.latLng.lng()
        })

        window.google.maps.event.addListener(array[i], 'dragend', (e) => {
          this.form.coordinates.find(coor => coor.lat === this.lat).lat = e.latLng.lat()
          this.form.coordinates.find(coor => coor.lng === this.lng).lng = e.latLng.lng()

          const map = this.initMap(this.form.coordinates[0])
          const poly = this.polygon(this.form.coordinates)
          poly.setMap(map)
          this.setMarkers(this.form.coordinates, map)
        })
      }
    },
    removePolygon () {
      this.form.coordinates = []
      this.map = this.initMap({ lat: 19.432608, lng: -99.133209 })
      this.poly = this.polygon()
      this.poly.setMap(this.map)
      this.map.addListener('click', this.addLatLng)
    },
    addLatLng (event) {
      const path = this.poly.getPath()

      path.push(event.latLng)
      this.form.coordinates.push({ lat: event.latLng.lat(), lng: event.latLng.lng() })

      const marker = new window.google.maps.Marker({
        position: event.latLng,
        title: `# ${path.getLength()}`,
        map: this.map,
        draggable: true
      })

      window.google.maps.event.addListener(marker, 'mousedown', (event) => {
        this.lat = event.latLng.lat()
        this.lng = event.latLng.lng()
      })

      window.google.maps.event.addListener(marker, 'dragend', (ev) => {
        this.form.coordinates.find(coor => coor.lat === this.lat).lat = ev.latLng.lat()
        this.form.coordinates.find(coor => coor.lng === this.lng).lng = ev.latLng.lng()

        this.poly.setMap(null)
        this.poly = this.polygon(this.form.coordinates)
        this.poly.setMap(this.map)
      })
    },
    async submit () {
      this.overlay = true
      try {
        const polygons = {}
        const polygon = []
        const coordinates = this.form.coordinates.map(coor => {
          return [
            coor.lng,
            coor.lat
          ]
        })
        coordinates.push(coordinates[0])
        polygon.push(coordinates)
        polygons.type = 'Polygon'
        polygons.coordinates = polygon
        const form = new FormData()
        form.append('polygons', JSON.stringify(polygons))
        await this.$api.put(`/v1/providers/${this.provider}/settings`, form)
        this.$toasted.show('Las coordenadas se han guardado con éxito', { duration: 3000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    }
  }
}
</script>
